import { PolicyComponentsActionTypes, PolicyComponentsActions } from "../actions/policy-components-actions";
import { PolicyComponentsState } from "@idw-types/state/policy-components-state";

export const initialPolicyComponentsState: PolicyComponentsState = {
    policyComponents: {
        policyComponents: null,
        isLoading: false
    }
}

export const policyComponentsReducer = (
    state: PolicyComponentsState = initialPolicyComponentsState,
    action: PolicyComponentsActions
): PolicyComponentsState => {
    switch (action.type) {
        // Policy Components
        case PolicyComponentsActionTypes.SET_POLICY_COMPONENTS_LOADING:
            return {
                ...state,
                policyComponents: {
                    ...(action.payload.isLoading
                        ? { ...initialPolicyComponentsState.policyComponents }
                        : { ...state.policyComponents }),
                    isLoading: action.payload.isLoading
                }
            };
        case PolicyComponentsActionTypes.SET_POLICY_COMPONENTS:
            return {
                ...state,
                policyComponents: {
                    policyComponents: action.payload.policyComponents,
                    isLoading: false
                }
            };
        case PolicyComponentsActionTypes.ADD_POLICY_COMPONENT:
            return {
                ...state,
                policyComponents: {
                    ...state.policyComponents,
                    policyComponents: state.policyComponents.policyComponents
                        ? [...state.policyComponents.policyComponents, action.payload.policyComponent]
                        : [action.payload.policyComponent]
                }
            };
        default:
            return state;
    }
};